
(function() {
  'use strict';

  class ProductTabs {
    constructor(section) {
      this.section = section;
      this.tabs = section.querySelectorAll('[data-tab-index]');
      this.panels = section.querySelectorAll('[data-panel-index]');
      this.currentTabIndex = 0;
      this.sliders = [];
      
      this.init();
    }

    init() {
      this.setupTabs();
      this.initSliders();
    }

    setupTabs() {
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => {
          this.switchTab(index);
        });
      });
    }

    switchTab(index) {
      if (index === this.currentTabIndex) return;
      
      // Update tabs
      this.tabs.forEach((tab, i) => {
        if (i === index) {
          tab.classList.add('product-tabs__tab--active');
        } else {
          tab.classList.remove('product-tabs__tab--active');
        }
      });
      
      // Update panels
      this.panels.forEach((panel, i) => {
        if (i === index) {
          panel.classList.add('product-tabs__panel--active');
        } else {
          panel.classList.remove('product-tabs__panel--active');
        }
      });
      
      this.currentTabIndex = index;
      
      // Reinitialize slider for active panel
      const activePanel = this.panels[index];
      const slider = activePanel.querySelector('[data-product-slider]');
      if (slider) {
        this.initSlider(slider, index);
      }
    }

    initSliders() {
      this.panels.forEach((panel, index) => {
        const slider = panel.querySelector('[data-product-slider]');
        if (slider) {
          this.initSlider(slider, index);
        }
      });
    }

    initSlider(slider, panelIndex) {
      const track = slider.querySelector('[data-slider-track]');
      const slides = slider.querySelectorAll('[data-slide-index]');
      const prevBtn = slider.closest('.product-tabs__panel').querySelector('[data-slider-prev]');
      const nextBtn = slider.closest('.product-tabs__panel').querySelector('[data-slider-next]');
      const progressBar = slider.closest('.product-tabs__panel').querySelector('[data-progress-bar]');
      
      if (!track || slides.length === 0) return;
      
      // Liquid already applies the products_limit, so the length here is the actual limit
      const totalSlides = slides.length;
      
      const sliderInstance = {
        track: track,
        slides: slides,
        prevBtn: prevBtn,
        nextBtn: nextBtn,
        progressBar: progressBar,
        currentIndex: 0,
        isDragging: false,
        startX: 0,
        currentX: 0,
        translateX: 0,
        prevTranslate: 0,
        animationID: null,
        slideWidth: 0,
        visibleSlides: 4,
        gap: 16,
        totalSlides: totalSlides
      };
      
      // Calculate visible slides
      this.calculateVisibleSlides(sliderInstance);
      
      // Setup event listeners
      if (prevBtn) {
        prevBtn.addEventListener('click', () => this.prevSlide(sliderInstance));
      }
      
      if (nextBtn) {
        nextBtn.addEventListener('click', () => this.nextSlide(sliderInstance));
      }
      
      // Drag disabled - only use navigation dots
      // this.setupDrag(slider, sliderInstance);
      this.updateSliderPosition(sliderInstance);
      this.updateProgressBar(sliderInstance);
      
      // Handle resize
      let resizeTimer;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          this.calculateVisibleSlides(sliderInstance);
          this.updateSliderPosition(sliderInstance);
          this.updateProgressBar(sliderInstance);
        }, 250);
      });
      
      this.sliders[panelIndex] = sliderInstance;
    }

    calculateVisibleSlides(sliderInstance) {
      const slider = sliderInstance.track.closest('.product-tabs__slider');
      if (!slider || sliderInstance.slides.length === 0) return;
      
      const sliderWidth = slider.offsetWidth;
      const slideWidth = sliderInstance.slides[0].offsetWidth;
      const gap = parseInt(window.getComputedStyle(sliderInstance.track).gap) || 16;
      
      sliderInstance.slideWidth = slideWidth + gap;
      sliderInstance.gap = gap;
      
      // Calculate how many slides can fit in the visible area
      if (window.innerWidth <= 480) {
        sliderInstance.visibleSlides = 1;
      } else if (window.innerWidth <= 749) {
        sliderInstance.visibleSlides = 2;
      } else if (window.innerWidth <= 1024) {
        sliderInstance.visibleSlides = 3;
      } else {
        sliderInstance.visibleSlides = 4;
      }
      
      // Ensure visibleSlides doesn't exceed totalSlides (product limit)
      sliderInstance.visibleSlides = Math.min(sliderInstance.visibleSlides, sliderInstance.totalSlides);
    }

    setupDrag(slider, sliderInstance) {
      // Mouse events
      slider.addEventListener('mousedown', (e) => this.handleStart(e, sliderInstance));
      slider.addEventListener('mousemove', (e) => this.handleMove(e, sliderInstance));
      slider.addEventListener('mouseup', () => this.handleEnd(sliderInstance));
      slider.addEventListener('mouseleave', () => this.handleEnd(sliderInstance));
      
      // Touch events
      slider.addEventListener('touchstart', (e) => this.handleStart(e, sliderInstance), { passive: true });
      slider.addEventListener('touchmove', (e) => this.handleMove(e, sliderInstance), { passive: false });
      slider.addEventListener('touchend', () => this.handleEnd(sliderInstance));
    }

    getPositionX(event) {
      return event.type.includes('mouse') ? event.clientX : event.touches[0].clientX;
    }

    handleStart(event, sliderInstance) {
      sliderInstance.isDragging = true;
      sliderInstance.startX = this.getPositionX(event);
      sliderInstance.track.classList.add('is-dragging');
      sliderInstance.animationID = requestAnimationFrame(() => this.animation(sliderInstance));
    }

    handleMove(event, sliderInstance) {
      if (!sliderInstance.isDragging) return;
      
      event.preventDefault();
      sliderInstance.currentX = this.getPositionX(event);
      sliderInstance.translateX = sliderInstance.currentX - sliderInstance.startX;
    }

    handleEnd(sliderInstance) {
      if (!sliderInstance.isDragging) return;
      
      sliderInstance.isDragging = false;
      sliderInstance.track.classList.remove('is-dragging');
      cancelAnimationFrame(sliderInstance.animationID);
      
      const movedBy = sliderInstance.translateX;
      const threshold = 50;
      
      if (movedBy < -threshold) {
        this.nextSlide(sliderInstance);
      } else if (movedBy > threshold) {
        this.prevSlide(sliderInstance);
      } else {
        this.updateSliderPosition(sliderInstance);
      }
      
      sliderInstance.translateX = 0;
      sliderInstance.prevTranslate = 0;
    }

    animation(sliderInstance) {
      this.setSliderPosition(sliderInstance);
      if (sliderInstance.isDragging) {
        sliderInstance.animationID = requestAnimationFrame(() => this.animation(sliderInstance));
      }
    }

    setSliderPosition(sliderInstance) {
      const currentTranslate = sliderInstance.prevTranslate + sliderInstance.translateX;
      sliderInstance.track.style.transform = `translateX(${currentTranslate}px)`;
    }

    updateSliderPosition(sliderInstance) {
      this.calculateVisibleSlides(sliderInstance);
      
      // Use totalSlides which represents the product limit (can be up to 50)
      const totalSlides = sliderInstance.totalSlides || sliderInstance.slides.length;
      
      // Calculate max index based on product limit
      // maxIndex should be the last position where we can show visibleSlides
      // Example: 20 products, 4 visible = maxIndex = 16 (showing products 16-19)
      const maxIndex = totalSlides > sliderInstance.visibleSlides 
        ? totalSlides - sliderInstance.visibleSlides 
        : 0;
      
      // Clamp currentIndex to valid range (0 to maxIndex)
      // This prevents scrolling beyond the product limit
      sliderInstance.currentIndex = Math.max(0, Math.min(sliderInstance.currentIndex, maxIndex));
      
      sliderInstance.prevTranslate = -sliderInstance.currentIndex * sliderInstance.slideWidth;
      sliderInstance.track.style.transform = `translateX(${sliderInstance.prevTranslate}px)`;
      
      // Update navigation buttons based on product limit (supports up to 50 products)
      if (sliderInstance.prevBtn) {
        if (totalSlides <= sliderInstance.visibleSlides) {
          sliderInstance.prevBtn.disabled = true;
        } else {
          sliderInstance.prevBtn.disabled = sliderInstance.currentIndex === 0;
        }
      }
      if (sliderInstance.nextBtn) {
        if (totalSlides <= sliderInstance.visibleSlides) {
          sliderInstance.nextBtn.disabled = true;
        } else {
          // Disable when we reach the last possible position
          sliderInstance.nextBtn.disabled = sliderInstance.currentIndex >= maxIndex;
        }
      }
      
      this.updateProgressBar(sliderInstance);
    }

    prevSlide(sliderInstance) {
      const totalSlides = sliderInstance.totalSlides || sliderInstance.slides.length;
      
      if (totalSlides <= sliderInstance.visibleSlides) {
        return;
      }
      
      const step = sliderInstance.visibleSlides;
      sliderInstance.currentIndex = Math.max(0, sliderInstance.currentIndex - step);
      this.updateSliderPosition(sliderInstance);
    }

    nextSlide(sliderInstance) {
      const totalSlides = sliderInstance.totalSlides || sliderInstance.slides.length;
      
      if (totalSlides <= sliderInstance.visibleSlides) {
        return;
      }
      
      const maxIndex = Math.max(0, totalSlides - sliderInstance.visibleSlides);
      const step = sliderInstance.visibleSlides;
      sliderInstance.currentIndex = Math.min(maxIndex, sliderInstance.currentIndex + step);
      this.updateSliderPosition(sliderInstance);
    }

    updateProgressBar(sliderInstance) {
      if (!sliderInstance.progressBar) return;
      
      const totalSlides = sliderInstance.totalSlides || sliderInstance.slides.length;
      const visibleSlides = sliderInstance.visibleSlides;
      let progress = 0;
      
      if (totalSlides <= visibleSlides) {
        progress = 100;
      } else {
        const maxIndex = totalSlides - visibleSlides;
        if (maxIndex > 0) {
          progress = (sliderInstance.currentIndex / maxIndex) * 100;
        } else {
          progress = 100;
        }
      }
      
      progress = Math.max(0, Math.min(100, progress));
      sliderInstance.progressBar.style.width = `${progress}%`;
    }
  }

  // Initialize tabs when DOM is ready
  function initProductTabs() {
    const productTabs = document.querySelectorAll('.product-tabs[data-section-id]');
    productTabs.forEach(section => {
      new ProductTabs(section);
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductTabs);
  } else {
    initProductTabs();
  }

  // Re-initialize on section load (for theme editor)
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      const section = event.detail.container.querySelector('.product-tabs[data-section-id]');
      if (section) {
        new ProductTabs(section);
      }
    });
  }
})();

